<template>
  <div
    class="d-flex align-items-center colg-forminput"
    ref="customSelect"
    :class="{
      'w-100': label == 'nolabel',
    }"
  >
    <div
      class="d-flex flex-column"
      :class="singlerow ? 'w-20' : 'w-40'"
      v-if="label != 'nolabel'"
    >
      <label class="mb-0 fs-14 fw-500 font-mont color-344054 pr-2">
        {{ label }}
        <span v-if="mandatory" class="color-red">*</span>
      </label>
      <label class="mb-0 fs-13 fw-300 font-mont color-344054 style-italic">
        {{ sublabel }}
      </label>
    </div>
    <div
      class="position-relative"
      :class="[
        singlerow ? 'w-80class ml-n1' : 'w-60',
        { 'w-100': label == 'nolabel' },
      ]"
    >
      <b-form-input
        :id="'autocomplete' + id"
        debounce="300"
        ref="autocompleteInput"
        :value="selectedCity"
        :placeholder="placeholder"
        class="w-100"
        @input="handleInput($event)"
        @focus="onInputFocus"
        :disabled="disabled"
        :class="{ 'border-error': error }"
        :type="type"
      />

      <ul
        v-if="showOptions && citySuggestions.length"
        class="select-options"
        @scroll.passive="handleScrollLoadMore"
        ref="suggestionList"
      >
        <li
          v-for="(item, index) in citySuggestions"
          :key="index"
          @click="selectCity(item)"
          :class="{
            'search-select-option': true,
            selected: index === highlightedIndex,
          }"
        >
          {{
            id === "collegeName"
              ? item.city
              : isFullAddress
              ? item.fullAddress
              : id === "state"
              ? item.state
              : `${item.city}, ${item.state}`
          }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getSuggestionCollege } from "@/utils/apiFunction";
export default {
  props: {
    mandatory: Boolean,
    label: String,
    sublabel: String,
    placeholder: String,
    singlerow: Boolean,
    value: String,
    disabled: Boolean,
    error: Boolean,
    id: {
      type: String,
    },
    isCityOrState: {
      type: Boolean,
      default: false,
    },
    isFullAddress: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      selectedCity: "",
      selectedCityObj: {},
      citySuggestions: [],
      showOptions: false,
      highlightedIndex: -1,
      page: 0,
      hasMore: true,
      loading: false,
      lastQuery: "",
    };
  },
  mounted() {
    this.selectedCity = this.value || "";

    if (this.isCityOrState || this.isFullAddress) {
      this.initialize();
    }

    if (this.id === "collegeName") {
      this.$nextTick(() => {
        const input = document.getElementById("autocomplete" + this.id);
        if (input) {
          input.addEventListener("keydown", this.handleKeyPressText);
        }
      });
    }

    document.addEventListener("click", this.closeDropdownOnClickOutside);
  },

  watch: {
    value(val) {
      this.selectedCity = val;
    },
  },
  methods: {
    onInputFocus() {
      if (this.id === "collegeName") {
        this.fetchCollegeSuggestions(this.selectedCity || "", true); // force fetch on focus
        this.showOptions = true;
      }
    },
    handleScrollLoadMore() {
      const el = this.$refs.suggestionList;
      if (!el || this.loading || !this.hasMore) return;

      const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;

      if (nearBottom && this.id === "collegeName") {
        this.fetchCollegeSuggestions(this.lastQuery);
      }
    },
    async fetchCollegeSuggestions(query, isNewQuery = false) {
      if (this.loading || (!this.hasMore && !isNewQuery)) return;

      if (isNewQuery) {
        this.page = 0;
        this.hasMore = true;
        this.citySuggestions = [];
      }

      this.loading = true;

      try {
        const payload = {
          institute: query,
          page: this.page,
        };

        const resp = await getSuggestionCollege(payload);

        if (resp.status === 200) {
          const responseData = resp.data.data.response || [];

          if (responseData.length === 0) {
            this.hasMore = false;
          } else {
            const newSuggestions = responseData.map((item) => ({
              city: item.text,
              key: item.value,
            }));

            this.citySuggestions = [
              ...(isNewQuery ? [] : this.citySuggestions),
              ...newSuggestions,
            ];
            this.page += 1;
            this.showOptions = this.citySuggestions.length > 0;
          }
        } else {
          this.hasMore = false;
        }
      } catch (error) {
        console.error("fetchCollegeSuggestions error:", error);
        this.hasMore = false;
      } finally {
        this.loading = false;
      }
    },
    initialize() {
      this.$nextTick(() => {
        const input = document.getElementById("autocomplete" + this.id);
        if (!input) return;

        const autocompleteService =
          new window.google.maps.places.AutocompleteService();

        // All Indian states
        const allStates = [
          "Andhra Pradesh",
          "Arunachal Pradesh",
          "Assam",
          "Bihar",
          "Chhattisgarh",
          "Goa",
          "Gujarat",
          "Haryana",
          "Himachal Pradesh",
          "Jharkhand",
          "Karnataka",
          "Kerala",
          "Madhya Pradesh",
          "Maharashtra",
          "Manipur",
          "Meghalaya",
          "Mizoram",
          "Nagaland",
          "Odisha",
          "Punjab",
          "Rajasthan",
          "Sikkim",
          "Tamil Nadu",
          "Telangana",
          "Tripura",
          "Uttar Pradesh",
          "Uttarakhand",
          "West Bengal",
          "Andaman and Nicobar Islands",
          "Chandigarh",
          "Dadra and Nagar Haveli and Daman and Diu",
          "Delhi",
          "Jammu and Kashmir",
          "Ladakh",
          "Lakshadweep",
          "Puducherry",
        ];

        input.addEventListener("input", () => {
          this.selectedCity = input.value;

          if (this.id === "state") {
            const filtered = allStates.filter((state) =>
              state.toLowerCase().startsWith(input.value.toLowerCase())
            );
            this.citySuggestions = filtered.map((state) => ({ state }));
            this.showOptions = filtered.length > 0;
            return;
          }

          if (input.value.length > 0) {
            const request = {
              input: input.value,
              language: "en",
              componentRestrictions: { country: "in" },
            };

            if (this.isFullAddress) {
              request.types = ["address"];
            } else if (this.isCityOrState) {
              request.types = ["(cities)"];
            }

            autocompleteService.getPlacePredictions(
              request,
              (predictions, status) => {
                if (
                  status === window.google.maps.places.PlacesServiceStatus.OK &&
                  Array.isArray(predictions)
                ) {
                  if (this.isFullAddress) {
                    this.citySuggestions = predictions.map((prediction) => ({
                      fullAddress: prediction.description,
                    }));
                  } else {
                    this.citySuggestions = predictions.map((prediction) => ({
                      city: prediction.terms[0]?.value || "",
                      state: prediction.terms[1]?.value || "",
                    }));
                  }
                  this.showOptions = true;
                } else {
                  this.citySuggestions = [];
                  this.showOptions = false;
                }
              }
            );
          } else {
            this.citySuggestions = [];
            this.showOptions = false;
          }
        });

        input.addEventListener("keydown", this.handleKeyPressText);
        document.addEventListener("click", this.closeDropdownOnClickOutside);
      });
    },

    onInput(val) {
      this.selectedCity = val;
      this.$emit("input", val);
    },
    handleInput(val) {
      if (this.id === "email") {
        const lowerCased = val.toLowerCase();
        this.selectedCity = lowerCased;
        this.$emit("input", lowerCased);
        return;
      }

      if (this.id === "collegeName") {
        this.selectedCity = val;
        this.$emit("input", val);

        if (val !== this.lastQuery) {
          this.lastQuery = val;
          this.fetchCollegeSuggestions(val, true); // new query
        }

        this.showOptions = true; // ✅ Force dropdown to remain open
        return;
      }

      if (this.id === "pincode") {
        const cleaned = val.toString().replace(/\D/g, "").slice(0, 6);
        this.$nextTick(() => {
          const inputEl = this.$el.querySelector("input");
          if (inputEl && inputEl.value !== cleaned) {
            inputEl.value = cleaned;
          }
        });
        this.selectedCity = cleaned;
        this.$emit("input", cleaned);
        return;
      }

      if (this.type === "number") {
        const cleaned = val.toString().replace(/\D/g, "").slice(0, 10);
        this.$nextTick(() => {
          const inputEl = this.$el.querySelector("input");
          if (inputEl && inputEl.value !== cleaned) {
            inputEl.value = cleaned;
          }
        });
        this.$emit("input", cleaned);
      } else {
        this.onInput(val);
      }
    },
    handleKeyPressText(event) {
      if (!this.showOptions || !this.citySuggestions.length) return;

      if (event.key === "ArrowDown") {
        event.preventDefault();
        this.highlightedIndex =
          (this.highlightedIndex + 1) % this.citySuggestions.length;
        this.scrollIntoView();
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        this.highlightedIndex =
          (this.highlightedIndex - 1 + this.citySuggestions.length) %
          this.citySuggestions.length;
        this.scrollIntoView();
      } else if (event.key === "Enter") {
        event.preventDefault();
        const selected =
          this.citySuggestions[this.highlightedIndex] ||
          this.citySuggestions[0];

        if (selected) {
          this.selectCity(selected);
        }
      }
    },
    getSelectedIndex() {
      return this.citySuggestions.findIndex(
        (city) => city.city === this.selectedCityObj?.city
      );
    },

    setSelectedIndex(index) {
      this.selectedCityObj = this.citySuggestions[index];
      this.selectedCity = this.citySuggestions[index].city;
    },

    scrollIntoView() {
      this.$nextTick(() => {
        const selected = document.querySelector(
          ".search-select-option.selected"
        );
        if (selected) {
          selected.scrollIntoView({ block: "nearest", behavior: "smooth" });
        }
      });
    },
    closeDropdownOnClickOutside(event) {
      if (
        this.$refs.customSelect &&
        !this.$refs.customSelect.contains(event.target)
      ) {
        this.showOptions = false;
      }
    },

    openDropdown() {
      this.showOptions = true;
    },

    selectCity(item) {
      if (this.id === "city") {
        this.selectedCity = item.city;
        this.$emit("input", item.city);
        this.$emit("update-related-state", item.state);
      } else if (this.id === "state") {
        this.selectedCity = item.state;
        this.$emit("input", item.state);
      } else if (this.id === "collegeName") {
        this.selectedCity = item.city;
        this.$emit("input", item.city);
        this.$emit("college-selected", item);
      }

      this.highlightedIndex = -1;
      this.showOptions = false;
    },
  },
};
</script>

<style scoped>
.border-error {
  border: 1px solid red !important;
}
.select-options {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  width: 100%;
  max-height: 202px;
  overflow-y: auto;
  z-index: 10;
  border-radius: 4px;
  margin-block-start: 0 !important;
  padding-inline-start: 0;
  margin-bottom: 0;
}
.search-select-option {
  padding: 4px 10px;
  cursor: pointer;
  color: #333 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
}
.search-select-option:hover,
.search-select-option.selected {
  background-color: #f0f0f0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.colg-forminput .form-control:disabled,
.form-control[readonly] {
  background: #f7f7f7;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: unset;
}
</style>
